import {
  Autocomplete,
  Backdrop,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { Form, Formik } from "formik";
import moment from "moment";
import React, { Component } from "react";
import axios from "axios";
import { Auth_Proto, Auth_Domain, Auth_Port } from "../../Component/consts";
import {NumericFormat} from "react-number-format";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import Credentials, {
  currentTenant,
  thousandsdisplay,
  userid,
  financialyearstart,financialyearend, plloss, plprofit, currency, clientname,
  getFinancialYearLabel
} from "../../Common/Credentials.js";
import * as XLSX from 'xlsx'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import { spin } from "../../Common/NewLoader.jsx";
import Footer from "../../Component/Footer.js";
import Header from "../../Component/Header.js";
import Menu from "../../Component/Menu.js";
import NewJournalService from "../NewJournalService.js";
import "./table.css";
import { FormikTextField } from "../../CommonComponents/FormField.js";
import PlComponent from "./PlComponent.js";


let liab=[]
let asst=[]
let liabilityamt=[]
let assetamt=[]
let privyears=[]



const asstTotal = (asset) => {
  let total = 0;
  //  console.log(data)
  asset.forEach((asset) => {
    total += asset;
  });
  // console.log(total)

  return total;
};
const liaTotal = (liability) => {
  let total = 0;
  //  console.log(data)
  liability.forEach((liability) => {
    total += liability;
  });
  // console.log(total)
  return total;
};

export let debitexcess, creditexcess;
class BalanceSheet extends Component {
  constructor(props) {
    super(props);

    this.state = {
  subaccdata: [],
  liabval:0,
  liadif:0,
  asstval:0,
  astdif:0,
  combdata: [],
  liabilities:[],
  assets:[],
  fylist:[],
  liabilityamt:[],
  assetamt:[],
  loading: false,
  loader1:true,
  fyfrom:null,
  fyto:null,
  fyto1:null,
  debitexcess:0,
  creditexcess:0,

  // ✅ NEW
  finalLiabilities: 0,
  finalAssets: 0,
  profitDistributionRecord: null,
  partnerCurrentRecord: null
};
  }
  
  async onFySelect(value){

    let year
    this.setState({debitexcess:0,creditexcess:0,asstval:0,liabval:0,astdif:0,liadif:0, profitDistributionRecord: null, partnerCurrentRecord: null})
   // if(value.from!==financialyearstart){
      year={
       from: moment(value.from).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      to: moment(value.to).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),  
        tenantid:currentTenant
          }
      this.setState({fyfrom:value.from,fyto:value.to,fyto1:moment([value.from]).endOf('year').format('DD-MM-YYYY')})
    // }else{
    //   year={
    // from:'Cur',
    // to:'year',
    // tenantid:currentTenant
    //   }
    //   this.setState({fyfrom:financialyearstart,fyto:financialyearend,fyto1:moment([financialyearstart]).endOf('year').format('DD-MM-YYYY')})

    // }
    // alert(value.from+"  "+value.to)
    this.setState({ loading: true });
  // fetch P&L values (debitexcess / creditexcess) and include them in balance calculations
  const val = await PlComponent.onFySelect(value)
  // set P&L values into state then load assets/liabilities
  this.setState({debitexcess: val.debitexcess, creditexcess: val.creditexcess}, () => this.getData(year))
   // }


   
   
   // if(plprofit===undefined || plloss===undefined ){
   // NewPandL.onFySelect(value) 
    //  <NewPandL/>     // 
   // }
  }
 
calculateFinalTotals = () => {
  const { liabval, asstval, debitexcess, creditexcess, partnerCurrentRecord, profitDistributionRecord } = this.state;
  let oeAmt = 0;
  if (partnerCurrentRecord) {
    oeAmt = Number(partnerCurrentRecord.totalAmount || 0);
  } else if (profitDistributionRecord) {
    oeAmt = Number(profitDistributionRecord.totalDistributedAmount || 0);
  }
  let finalLiabilities = (liabval || 0) + (creditexcess || 0) + oeAmt;
  let finalAssets = (asstval || 0) + (debitexcess || 0);

  // Balance both sides
  if (finalLiabilities > finalAssets) {
    finalAssets = finalLiabilities;
  } else if (finalAssets > finalLiabilities) {
    finalLiabilities = finalAssets;
  }

  this.setState({
    finalLiabilities,
    finalAssets
  });
};

async getData(year){
  let asst = await NewJournalService.getAssets(year);
  let liab = await NewJournalService.getLiabilities(year);

  // Fetch profit distribution record if any
  let profitDistributionRecord = null;
  const candidateYearIds = new Set();
  const getFyId = (f, t) => {
    if (!f || !t) return null;
    return getFinancialYearLabel(f, t) || null;
  };

  if (year && year.from && year.to) {
    const yId = getFyId(year.from, year.to);
    if (yId) candidateYearIds.add(yId);
  }
  if (this.state.fyfrom && this.state.fyto) {
    const yId = getFyId(this.state.fyfrom, this.state.fyto);
    if (yId) candidateYearIds.add(yId);
  }
  if (this.state.fylist && this.state.fylist.length > 0) {
    const matched = this.state.fylist.find(f => 
      (f.from && year && year.from && moment(f.from).format("YYYY-MM-DD") === moment(year.from).format("YYYY-MM-DD")) ||
      (f.from && this.state.fyfrom && moment(f.from).format("YYYY-MM-DD") === moment(this.state.fyfrom).format("YYYY-MM-DD"))
    );
    if (matched) {
      const yId = getFyId(matched.from, matched.to);
      if (yId) candidateYearIds.add(yId);
      if (matched.id) candidateYearIds.add(String(matched.id));
    }
  }
  candidateYearIds.add('current');

  // Fetch partner current record if any
  let partnerCurrentRecord = null;
  for (const yId of candidateYearIds) {
    if (!yId) continue;
    try {
      const res = await axios.get(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/accounts/partnercurrent/${currentTenant}/${yId}`);
      if (res.data && (res.data.id || res.data.totalAmount !== undefined)) {
        partnerCurrentRecord = res.data;
        break;
      }
    } catch (err) {}
  }

  for (const yId of candidateYearIds) {
    if (!yId) continue;
    try {
      const res = await axios.get(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/accounts/record/${currentTenant}/${yId}`);
      if (res.data && (res.data.id || res.data.netProfit !== undefined)) {
        profitDistributionRecord = res.data;
        break;
      }
    } catch (err) {}
  }

  this.setState({
    assets: asst.data,
    liabilities: liab.data,
    profitDistributionRecord: profitDistributionRecord,
    partnerCurrentRecord: partnerCurrentRecord
  }, () => {
    this.liabsubheads();
    this.assetsubheads();
    // ✅ close loader AFTER everything
    setTimeout(() => {
      this.setState({ loading: false, loader1: false });
    }, 300);
  });
}
  
// componentDidUpdate(prevProps, prevState) {
//   if (
//     prevState.liabval !== this.state.liabval ||
//     prevState.asstval !== this.state.asstval ||
//     prevState.creditexcess !== this.state.creditexcess ||
//     prevState.debitexcess !== this.state.debitexcess ||
//     prevState.astdif !== this.state.astdif ||
//     prevState.liadif !== this.state.liadif
//   ) {
//     this.calculateFinalTotals();
//   }
// }
   
  componentDidMount() {
   
    this.setState({ loading: true });
// console.log(financialyearstart + " And "+ financialyearend)
   

    if (userid === undefined) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      this.props.navigate(`/`);
    }

  
 
    // NewJournalService.getAllLedgers(currentTenant).then((response) => {
    //   this.setState({ combdata: response.data });

      //  // this.setState({combdata:response.data})
  //  })

  NewJournalService.getFinancialYears(currentTenant).then((response) => {
    this.setState({ fylist: response.data },()=>this.fyyears())
    this.setState({ loading: false,loader1:false });
  })

 
    .catch((e)=>{
      if(e.response.data.error ==="Unauthorized"){
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
      }

  })
  }
  liabsubheads(){
    let valliab=[]
    liab=[...new Set(this.state.liabilities.map((e) => { return e.shname})),]
    //liab=this.state.liabilities.map((e) => { return e.shname})
    valliab=this.state.liabilities.map((e) => { return e.amount})
    liabilityamt=valliab.map((val,i)=>{return Math.abs(val)})
   this.setState({liabilityamt:liabilityamt}, () => {
  this.setState({liabval:liaTotal(liabilityamt)}
);
});
    //this.setState({loader1:false})
  }
  assetsubheads(){
    let valasset=[]
    asst=[...new Set(this.state.assets.map((e) => { return e.shname})),]
    valasset=this.state.assets.map((e) => { return e.amount})
    assetamt=valasset.filter((val,i)=>{return Math.abs(val)})
   // alert(asstTotal(valasset))
   this.setState({assetamt:assetamt}, () => {
  this.setState({asstval:asstTotal(this.state.assetamt)},() => { this.addDiff(); this.calculateFinalTotals(); });
});
    //this.setState({loader1:false})
  }
  addDiff(){
  const liabilitiesTotal = this.state.liabval || 0;
  const assetsTotal = this.state.asstval || 0;

  if (liabilitiesTotal === assetsTotal) {
    this.setState({ liadif: 0, astdif: 0 });
  } else if (liabilitiesTotal > assetsTotal) {
    this.setState({ liadif: liabilitiesTotal - assetsTotal, astdif: 0 });
  } else {
    this.setState({ astdif: assetsTotal - liabilitiesTotal, liadif: 0 });
  }
  
}
  fyyears(){
    let def={from:financialyearstart,to:financialyearend}
    const rawList = (this.state.fylist || []).concat(def);
    const uniqueList = [];
    const seen = new Set();
    rawList.forEach((item) => {
      if (!item || !item.from || !item.to) return;
      const lbl = getFinancialYearLabel(item.from, item.to);
      if (!seen.has(lbl)) {
        seen.add(lbl);
        uniqueList.push(item);
      }
    });
    this.setState({ fylist: uniqueList });
  }
  // calcSubTotal(name1){
   
  
  //   let a =this.state.liabilities.filter((e)=>{return e.shname===name1})
  //   subheads=a.filter((e)=>{return e.shname})

  //  // console.log(subheads)

  // }

  renderFormattedAccountingValue(val) {
    if (val === null || val === undefined || val === '') return '-';
    const cleaned = typeof val === 'string' ? val.replace(/,/g, '').trim() : val;
    const num = Number(cleaned);
    if (isNaN(num) || num === 0) return '-';
    if (num < 0) {
      const absVal = Math.abs(num);
      return (
        <span className="text-danger font-weight-bold">
          (<NumericFormat
            displayType={"text"}
            decimalScale={2}
            fixedDecimalScale={true}
            thousandSeparator={true}
            thousandsGroupStyle={thousandsdisplay || 'lakh'}
            value={absVal}
          />)
        </span>
      );
    }
    return (
      <NumericFormat
        displayType={"text"}
        decimalScale={2}
        fixedDecimalScale={true}
        thousandSeparator={true}
        thousandsGroupStyle={thousandsdisplay || 'lakh'}
        value={num}
      />
    );
  }

  render() {
   

    

  //  let shname1
  // let liab=[...new Set(this.state.liabilities.map((e) => { return e.shname})),];
  //         shname1=''
  //           if(liab.find((e,i)=>e!==null)){
  //              shname1=liab.find((e,i)=>e.valueOf(i));
  //           }
  // console.log(liab)

    return (
      <div>
        
        <Header />
        <Menu />
<Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.loader1}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <div className="content-wrapper">
          <div className="card card-info">
            {/* <div className="card-header">
              <h3 className="card-title">Balance Sheet</h3>
            </div> */}
            <ol className="breadcrumb float-sm-right">
              <li className="breadcrumb-item text-secondary">
                <Link to="/accounts">Home</Link>
              </li>

              <li className="breadcrumb-item active text-backgroundColour">Balance Sheet</li>
            </ol>
            <div className="form-row">
              <div className="card-body">
                <div className="text-center">
                  {this.state.loading === true ? spin : ""}
                </div>

                <Formik  initialValues={{ }}
      onSubmit={this.onSubmit}
      validateOnChange={true}
      validate={this.validate}
      enableReinitialize={true}>
                  {({ values, setFieldValue }) => (
                    <Form>
                        <fieldset className="form-group col-md-4 mt-0 mb-3">
<Autocomplete id="fylist1" className="fy-select " name="fylist" options={this.state.fylist} getOptionLabel={(option) => option ? getFinancialYearLabel(option.from, option.to) : ''}
 // isOptionEqualToValue ={(option) => option.id}
value={values.fylist? undefined: undefined} onChange={(e, value) => {setFieldValue("fylist", value) && this.onFySelect(value)}}
renderInput={(params) => (
<FormikTextField {...params} className="form-control mb-3" type="text" name="fylist" label="Select Financial year" 
  // onBlur={(e) => {this.onAeChange(e.target.value, values)}}
//  onBlur={(e) => {this.onSoSelect(values)}} 
  variant="standard" fullWidth/>)}/></fieldset>
                      <div className="d-flex justify-content-between align-items-center">
                        <h5 className="text-center mb-0">Balance Sheet</h5>
                        <div className="btn-group">
                          <button className="btn btn-sm btn-outline-primary" onClick={() => this.exportToExcel()} title="Export to Excel"
                            disabled={this.state.loading || !(this.state.fyfrom && this.state.fyto && (this.state.liabval || this.state.asstval))}>Export Excel</button>
                          <button className="btn btn-sm btn-outline-secondary" onClick={() => this.exportToPDF()} title="Export to PDF"
                            disabled={this.state.loading || !(this.state.fyfrom && this.state.fyto && (this.state.liabval || this.state.asstval))}>Export PDF</button>
                        </div>
                      </div>
                      <div><p className="text-center">For the Financial Year - {this.state.fyfrom!==null?moment(this.state.fyfrom).format('DD-MM-YYYY'):'DD-MM-YYYY'} --- {this.state.fyto1!==null?moment(this.state.fyfrom).format('MM')==='01'?this.state.fyto1:moment(this.state.fyto).format('DD-MM-YYYY'):'DD-MM-YYYY'}
                     </p></div>

 <Table id="tb" className="table table-sm table-borderless col-md-12">
  <TableBody><TableRow>

  {/* --------------------------------------------------Left Side (Owner Equity & Liabilities)------------------------------------------------- */}

  <TableCell className="m-0 p-0 col-md-6" style={{ verticalAlign: 'top' }}>
  <Table id="tbliability" className="m-0 p-0 " style={{border:'0.5px solid #f3eaea'}}>
  <TableHead> 
    <TableRow>
      <TableCell className="text-left text-white backgroundColour">Owner Equity and Liabilities</TableCell>
      <TableCell className="text-right text-white backgroundColour">Amount</TableCell>
    </TableRow>
  </TableHead>
  
  <TableBody>
    {(() => {
      const isEquitySubhead = (shname) => {
        if (!shname) return false;
        const s = String(shname).toLowerCase();
        return s.includes('capital') || s.includes('equity') || s.includes('partner') || s.includes('share');
      };

      const allLiabilities = this.state.liabilities || [];
      const equityLedgers = allLiabilities.filter(l => isEquitySubhead(l.shname));
      const nonEquityLiabilities = allLiabilities.filter(l => !isEquitySubhead(l.shname));
      const nonEquityGroups = [...new Set(nonEquityLiabilities.map(l => l.shname))];

      const capitalTotal = equityLedgers.reduce((sum, l) => sum + (Number(l.amount) || 0), 0);
      let statutoryReserve = 0;
      let retainedEarnings = 0;
      let ownerEquityAmount = 0;
      let partnerAllocs = [];

      if (this.state.partnerCurrentRecord) {
        const pcRec = this.state.partnerCurrentRecord;
        ownerEquityAmount = Number(pcRec.totalAmount || 0);
        try {
          const rawAllocs = typeof pcRec.partnerDetails === 'string'
            ? JSON.parse(pcRec.partnerDetails)
            : pcRec.partnerDetails || [];
          partnerAllocs = rawAllocs.map(p => ({
            partnerId: p.partnerId,
            partnerName: p.partnerName,
            sharePercentage: p.sharePercentage,
            allocatedAmount: p.closingAmount !== undefined ? p.closingAmount : p.allocatedAmount
          }));
        } catch (e) { partnerAllocs = []; }

        if (this.state.profitDistributionRecord) {
          const rec = this.state.profitDistributionRecord;
          if (Number(rec.netProfit) < 0) {
            statutoryReserve = 0;
            retainedEarnings = rec.retainedEarningsAmount !== null && Number(rec.retainedEarningsAmount) < 0 
              ? Number(rec.retainedEarningsAmount) 
              : -Math.abs(Number(rec.netProfit));
          } else {
            statutoryReserve = Number(rec.statutoryReserveAmount || 0);
            retainedEarnings = Number(rec.retainedEarningsAmount || 0);
          }
        } else {
          if (this.state.debitexcess > 0) retainedEarnings = Number(this.state.debitexcess);
          else if (this.state.creditexcess > 0) retainedEarnings = -Number(this.state.creditexcess);
        }
      } else if (this.state.profitDistributionRecord) {
        const rec = this.state.profitDistributionRecord;
        if (Number(rec.netProfit) < 0) {
          statutoryReserve = 0;
          retainedEarnings = rec.retainedEarningsAmount !== null && Number(rec.retainedEarningsAmount) < 0 
            ? Number(rec.retainedEarningsAmount) 
            : -Math.abs(Number(rec.netProfit));
          ownerEquityAmount = Number(rec.totalDistributedAmount || 0);
        } else {
          statutoryReserve = Number(rec.statutoryReserveAmount || 0);
          retainedEarnings = Number(rec.retainedEarningsAmount || 0);
          ownerEquityAmount = Number(rec.totalDistributedAmount || 0);
        }

        try {
          partnerAllocs = typeof rec.partnerAllocations === 'string'
            ? JSON.parse(rec.partnerAllocations)
            : rec.partnerAllocations || [];
        } catch (e) { partnerAllocs = []; }
      } else {
        if (this.state.debitexcess > 0) retainedEarnings = Number(this.state.debitexcess);
        else if (this.state.creditexcess > 0) retainedEarnings = -Number(this.state.creditexcess);
      }

      const totalPartnersEquity = capitalTotal + statutoryReserve + ownerEquityAmount + retainedEarnings;

      return (
        <>
          {/* Owner Equity Sub-section */}
          <TableRow>
            <TableCell colSpan={2} className="p-0 border-0">
              <Table className="table table-sm table-borderless m-0">
                <TableHead className="thead-light">
                  <TableRow>
                    <TableCell className="text-sm font-weight-bold text-black border-0 pb-1" colSpan={2} style={{ textDecoration: 'underline' }}>
                      Owner Equity:
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* 1. Capital */}
                  <TableRow>
                    <TableCell className="text-sm text-left border-0" style={{ paddingLeft: '24px' }}>
                      {equityLedgers.length > 0 ? (
                        <div>
                          <span>capital</span>
                          {equityLedgers.map(l => (
                            <div key={l.id || l.name} className="small ml-2">
                              <Link to={{ pathname: "/ledgerview" }} state={l.name} className="text-blue">{l.name}</Link>
                              {equityLedgers.length > 1 && <span>: {this.renderFormattedAccountingValue(l.amount)}</span>}
                            </div>
                          ))}
                        </div>
                      ) : (
                        <span>capital</span>
                      )}
                    </TableCell>
                    <TableCell className="text-sm text-right border-0 align-top">
                      {this.renderFormattedAccountingValue(capitalTotal)}
                    </TableCell>
                  </TableRow>

                  {/* 2. Statutory reserve */}
                  <TableRow>
                    <TableCell className="text-sm text-left border-0" style={{ paddingLeft: '24px' }}>
                      Statutory reserve
                    </TableCell>
                    <TableCell className="text-sm text-right border-0">
                      {this.renderFormattedAccountingValue(statutoryReserve)}
                    </TableCell>
                  </TableRow>

                  {/* 3. Owner Equity (Allocations / Current Period Distribution) */}
                  <TableRow>
                    <TableCell className="text-sm text-left border-0" style={{ paddingLeft: '24px' }}>
                      <div>
                        <span>
                          Owner Equity
                          <Link
                            to="/partnercurrent"
                            className="ml-2 badge badge-info text-white"
                            style={{ textDecoration: 'none', fontSize: '10px', padding: '2px 6px', verticalAlign: 'middle' }}
                            title="Manage Partner Current / Owner Equity"
                          >
                            <i className="fas fa-edit mr-1"></i> Edit Partner Current
                          </Link>
                        </span>
                        {partnerAllocs && partnerAllocs.length > 0 && (
                          <div className="small ml-2">
                            {partnerAllocs.map((p, idx) => (
                              <div key={p.partnerId || idx} className={p.allocatedAmount < 0 ? "text-danger" : "text-success"}>
                                {p.partnerName} {p.sharePercentage ? `(${p.sharePercentage}%)` : ''}: {this.renderFormattedAccountingValue(p.allocatedAmount)}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </TableCell>
                    <TableCell className="text-sm text-right border-0 align-top">
                      {this.renderFormattedAccountingValue(ownerEquityAmount)}
                    </TableCell>
                  </TableRow>

                  {/* 4. Retained earnings */}
                  <TableRow>
                    <TableCell className="text-sm text-left border-0" style={{ paddingLeft: '24px' }}>
                      Retained earnings
                    </TableCell>
                    <TableCell className="text-sm text-right border-0">
                      {this.renderFormattedAccountingValue(retainedEarnings)}
                    </TableCell>
                  </TableRow>

                  {/* 5. Total Partners' Equity */}
                  <TableRow style={{ borderTop: '1px solid #333', borderBottom: '3px double #333', backgroundColor: '#fcfcfc' }}>
                    <TableCell className="text-sm font-weight-bold text-left text-black">
                      Total Partners' Equity
                    </TableCell>
                    <TableCell className="text-sm font-weight-bold text-right text-black">
                      {this.renderFormattedAccountingValue(totalPartnersEquity)}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableCell>
          </TableRow>

          {/* Other Liabilities (Non-Equity) */}
          {nonEquityGroups.map((sh, idx) => (
            <TableRow key={sh || idx}>
              <TableCell colSpan={2} className="p-0 border-0">
                <Table className="table table-sm table-borderless m-0 mt-2">
                  <TableHead className="thead-light">
                    <TableRow>
                      <TableCell className="text-sm text-left text-black font-weight-bold" colSpan={2}>
                        {sh}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {nonEquityLiabilities
                      .filter(l => l.shname === sh)
                      .map((resultsub) => (
                        <TableRow key={resultsub.id || resultsub.name}>
                          <TableCell className="text-sm text-left text-blue" style={{ paddingLeft: '24px' }}>
                            <Link to={{ pathname: "/ledgerview" }} state={resultsub.name}>{resultsub.name}</Link>
                          </TableCell>
                          <TableCell className="text-sm text-right text-blue">
                            {this.renderFormattedAccountingValue(resultsub.amount)}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableCell>
            </TableRow>
          ))}
        </>
      );
    })()}
  </TableBody>
  </Table>
  </TableCell>

 {/* --------------------------------------------------Right Side------------------------------------------------- */}

<TableCell className="m-0 p-0 col-md-6">
  <Table id="tblassets" className="m-0 p-0 " style={{border:'0.5px solid #f3eaea'}}>
  <TableHead> <TableRow><TableCell className="text-left text-white backgroundColour">Assets</TableCell>
  <TableCell className="text-right text-white backgroundColour">Amount</TableCell></TableRow>
  </TableHead>
  
  <TableBody>
   {asst.map((e,i) => (
  <TableRow>

  <TableCell className="m-0 p-0">
  <Table id="tbi1i" className="table table-sm table-borderless">
  <TableHead className="thead-light">
  <TableCell className="text-sm text-left text-black">
  {asst[i]}</TableCell>
   <TableCell className="text-sm text-left text-black"></TableCell>
  </TableHead>    
 {this.state.assets.map((rasset) => ( 
 <TableRow key={rasset.id}> 
 {rasset.shname === asst[i]  ?<>
 <TableCell className="text-sm text-left text-blue">{rasset.rule!==2?
 <Link to={{pathname: "/ledgerview"}} state={rasset.name}>{rasset.name}</Link>:rasset.name}</TableCell>
 <TableCell className="text-sm text-right text-blue">
 {<NumericFormat displayType={ "text" } decimalScale={2} fixedDecimalScale={true}  disabled={true} thousandSeparator={true}
                thousandsGroupStyle={thousandsdisplay} value={rasset.amount}>
 </NumericFormat>}</TableCell>
  </>:""}
   </TableRow>
  ))}

</Table>
</TableCell>
 </TableRow>
 ))}
</TableBody>
{/* Removed redundant Profit / Loss block; keep Add Net Profit / Less Net Loss visible */}
  <Table>
  <TableHead className="thead-light">
  <TableCell className="text-sm text-left text-black">Other Assets</TableCell>
   <TableCell className="text-sm text-left text-black"></TableCell>
  </TableHead>
  <TableRow className="col-md-12"> 
  <TableCell className="text-sm text-left text-blue">
   Other Assets</TableCell>
   <TableCell className="text-sm text-right text-blue">
   {<NumericFormat displayType={ "text" } decimalScale={2} fixedDecimalScale={true}  disabled={true} thousandSeparator={true}
                  thousandsGroupStyle={thousandsdisplay} value={this.state.liadif}>
   </NumericFormat>}</TableCell>
  </TableRow></Table>
 </Table>
 </TableCell>
 </TableRow>
 <TableRow >
<TableCell className="text-sm bg-light text-black">
<TableRow className="m-0 p-0 col-md-12 ">
<TableCell className="text-sm font-weight-bold text-left text-blue text-bold mt-0 mb-0 col-md-12">Liabilities Total</TableCell>
<TableCell className="text-sm font-weight-bold text-right text-blue text-bold mt-0 mb-0 col-md-12">
  {/*
    Final liabilities (capital) applies the P&L rule:
    - If creditexcess > 0 -> deduct creditexcess from liabilities
    - Else if debitexcess > 0 -> add debitexcess to liabilities
    FinalLiabilities = liabval + pAndL + astdif
  */}
  {/* {alert(this.state.liabval + " And " + this.state.creditexcess + " And " + this.state.debitexcess)} */}
  {<NumericFormat
  displayType={"text"}
  decimalScale={2}
  fixedDecimalScale={true}
  disabled={true}
  thousandSeparator={true}
  thousandsGroupStyle={thousandsdisplay}
  value={this.state.finalLiabilities || 0}
/>}</TableCell>
                {/* (liaTotal(liabilityamt) */}
                {/* - */}
</TableRow>
</TableCell>
<TableCell className="text-sm bg-light text-black">
<TableRow className="m-0 p-0 col-md-12 ">
<TableCell className="text-sm font-weight-bold text-left text-blue text-bold mt-0 mb-0 col-md-12">Asset Total</TableCell>
<TableCell className="text-sm font-weight-bold text-right text-blue text-bold mt-0 mb-0 col-md-12">
  {/*
    Final assets displayed here DOES NOT include P&L adjustments.
    FinalAssets = asstval + liadif
  */}
  {<NumericFormat
  displayType={"text"}
  decimalScale={2}
  fixedDecimalScale={true}
  disabled={true}
  thousandSeparator={true}
  thousandsGroupStyle={thousandsdisplay}
  value={this.state.finalAssets || 0}
/>}</TableCell>
{/* (asstTotal(assetamt)-plloss) */}
{/* - */}
</TableRow>
</TableCell>
 </TableRow>
</TableBody>
</Table>

                     

                      {/* <table id="table" hidden>
                        <thead>
                          <tr>
                            <th>Table</th>
                            <th>Table2</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td/>
                          </tr>
                        </tbody>
                      </table> */}
                    </Form>
                  )}
                </Formik>
                {/* <button onClick={() => this.pdf()}>Pdf</button> */}
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

// Export visible Balance Sheet to Excel
BalanceSheet.prototype.exportToExcel = function() {
  try {
    // Build worksheet data (array of arrays) safely in local scope
    const cur = currency || 'INR'
    const rows = []
    let ri = 0
    rows[ri++] = ['Section', 'Particulars', `Amount (${cur})`]

    // Owner Equity and Liabilities
    rows[ri++] = ['Owner Equity and Liabilities', '', '']
    rows[ri++] = ['Owner Equity:', '', '']

    const isEquitySubhead = (shname) => {
      if (!shname) return false;
      const s = String(shname).toLowerCase();
      return s.includes('capital') || s.includes('equity') || s.includes('partner') || s.includes('share');
    };

    const allLiabilities = this.state.liabilities || [];
    const equityLedgers = allLiabilities.filter(l => isEquitySubhead(l.shname));
    const nonEquityLiabilities = allLiabilities.filter(l => !isEquitySubhead(l.shname));
    const nonEquityGroups = [...new Set(nonEquityLiabilities.map(l => l.shname))];

    const capitalTotal = equityLedgers.reduce((sum, l) => sum + (Number(l.amount) || 0), 0);
    let statutoryReserve = 0;
    let retainedEarnings = 0;
    let ownerEquityAmount = 0;
    let partnerAllocs = [];

    if (this.state.partnerCurrentRecord) {
      const pcRec = this.state.partnerCurrentRecord;
      ownerEquityAmount = Number(pcRec.totalAmount || 0);
      try {
        const rawAllocs = typeof pcRec.partnerDetails === 'string'
          ? JSON.parse(pcRec.partnerDetails)
          : pcRec.partnerDetails || [];
        partnerAllocs = rawAllocs.map(p => ({
          partnerId: p.partnerId,
          partnerName: p.partnerName,
          sharePercentage: p.sharePercentage,
          allocatedAmount: p.closingAmount !== undefined ? p.closingAmount : p.allocatedAmount
        }));
      } catch (e) { partnerAllocs = []; }

      if (this.state.profitDistributionRecord) {
        const rec = this.state.profitDistributionRecord;
        if (Number(rec.netProfit) < 0) {
          statutoryReserve = 0;
          retainedEarnings = rec.retainedEarningsAmount !== null && Number(rec.retainedEarningsAmount) < 0 
            ? Number(rec.retainedEarningsAmount) 
            : -Math.abs(Number(rec.netProfit));
        } else {
          statutoryReserve = Number(rec.statutoryReserveAmount || 0);
          retainedEarnings = Number(rec.retainedEarningsAmount || 0);
        }
      } else {
        if (this.state.debitexcess > 0) retainedEarnings = Number(this.state.debitexcess);
        else if (this.state.creditexcess > 0) retainedEarnings = -Number(this.state.creditexcess);
      }
    } else if (this.state.profitDistributionRecord) {
      const rec = this.state.profitDistributionRecord;
      if (Number(rec.netProfit) < 0) {
        statutoryReserve = 0;
        retainedEarnings = rec.retainedEarningsAmount !== null && Number(rec.retainedEarningsAmount) < 0 
          ? Number(rec.retainedEarningsAmount) 
          : -Math.abs(Number(rec.netProfit));
        ownerEquityAmount = Number(rec.totalDistributedAmount || 0);
      } else {
        statutoryReserve = Number(rec.statutoryReserveAmount || 0);
        retainedEarnings = Number(rec.retainedEarningsAmount || 0);
        ownerEquityAmount = Number(rec.totalDistributedAmount || 0);
      }

      try {
        partnerAllocs = typeof rec.partnerAllocations === 'string'
          ? JSON.parse(rec.partnerAllocations)
          : rec.partnerAllocations || [];
      } catch (e) { partnerAllocs = []; }
    } else {
      if (this.state.debitexcess > 0) retainedEarnings = Number(this.state.debitexcess);
      else if (this.state.creditexcess > 0) retainedEarnings = -Number(this.state.creditexcess);
    }

    const totalPartnersEquity = capitalTotal + statutoryReserve + ownerEquityAmount + retainedEarnings;

    rows[ri++] = ['', '  capital', capitalTotal];
    rows[ri++] = ['', '  Statutory reserve', statutoryReserve];
    rows[ri++] = ['', '  Owner Equity', ownerEquityAmount];
    if (partnerAllocs && partnerAllocs.length > 0) {
      partnerAllocs.forEach(p => {
        rows[ri++] = ['', `    ${p.partnerName}${p.sharePercentage ? ` (${p.sharePercentage}%)` : ''}`, Number(p.allocatedAmount) || 0];
      });
    }
    rows[ri++] = ['', '  Retained earnings', retainedEarnings];
    rows[ri++] = ['', 'Total Partners\' Equity', totalPartnersEquity];

    // Other Liabilities
    rows[ri++] = ['', '', ''];
    nonEquityGroups.forEach(sh => {
      rows[ri++] = [sh || '', '', ''];
      nonEquityLiabilities.filter(l => l.shname === sh).forEach(l => {
        rows[ri++] = ['', `  ${l.ledname || l.name}`, Number(l.amount) || 0];
      });
    });

    rows[ri++] = ['', '', '']
    // Assets
    rows[ri++] = ['Assets', '', '']
    const asstGroups = [...new Set((this.state.assets || []).map(a => a.shname))]
    asstGroups.forEach(sh => {
      rows[ri++] = [sh || '', '', '']
      ;(this.state.assets || []).filter(a => a.shname === sh).forEach(a => {
        rows[ri++] = ['', `  ${a.ledname || a.name}`, Number(a.amount) || 0]
      })
    })

    const liabilitiesTotal = (this.state.liabval || 0) + ((this.state.creditexcess && this.state.creditexcess>0)? -Math.abs(this.state.creditexcess) : (this.state.debitexcess && this.state.debitexcess>0)? Math.abs(this.state.debitexcess) : 0) + (this.state.astdif || 0)
    const assetsTotal = (this.state.asstval || 0) + (this.state.liadif || 0)
    rows[ri++] = ['', 'Liabilities Total', this.state.finalLiabilities.toFixed(2)]
    rows[ri++] = ['', 'Asset Total', this.state.finalAssets.toFixed(2)]

    // Convert to worksheet and workbook
    const ws = XLSX.utils.aoa_to_sheet(rows)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'BalanceSheet')

    // Write workbook to binary and trigger download
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
    const blob = new Blob([wbout], { type: 'application/octet-stream' })
    const fname = `BalanceSheet_${this.state.fyfrom || 'FY'}.xlsx`
    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, fname)
    } else {
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fname)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    }
  } catch (e) {
    console.error('Failed to export Excel (.xlsx)', e)
    // fallback to CSV if anything unexpected happens
    try {
      // minimal CSV fallback
      const curx = currency || 'INR'
      const csvrows = rows.map(r => r.map(c => typeof c === 'string' ? '"' + String(c).replace(/"/g, '""') + '"' : c).join(','))
      const csvblob = new Blob([csvrows.join('\n')], { type: 'text/csv;charset=utf-8;' })
      const fname = `BalanceSheet_${this.state.fyfrom || 'FY'}.csv`
      const link = document.createElement('a')
      const url = URL.createObjectURL(csvblob)
      link.href = url
      link.setAttribute('download', fname)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    } catch (e2) {
      console.error('CSV fallback also failed', e2)
      alert('Export to Excel failed: ' + (e && e.message ? e.message : 'unknown'))
    }
  }
}

// Export visible Balance Sheet to PDF
BalanceSheet.prototype.exportToPDF = async function() {
  try {
  // Use landscape for denser layout
  const doc = new jsPDF('l', 'pt', 'a4')
  const marginLeft = 24
  let cursorY = 28

    // attempt to load logo
    try {
      const logoUrl = Credentials && Credentials.getLogo ? Credentials.getLogo() : (Credentials.logo || '')
      if (logoUrl) {
        const res = await fetch(logoUrl)
        const blob = await res.blob()
        const imgData = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
        doc.addImage(imgData, 'PNG', marginLeft, cursorY, 80, 40)
      }
    } catch (e) {
      // ignore logo errors
    }

    const pageWidth = doc.internal.pageSize.getWidth()
    const company = clientname || ''
    if (company) {
      doc.setFontSize(16)
      doc.text(company, pageWidth / 2, cursorY + 10, { align: 'center' })
      cursorY += 20
    }

    doc.setFontSize(14)
    doc.text('Balance Sheet', pageWidth / 2, cursorY + 20, { align: 'center' })
    cursorY += 30

    const fyLabel = (this.state.fyfrom && this.state.fyto) ? getFinancialYearLabel(this.state.fyfrom, this.state.fyto) : ''
    if (fyLabel) {
      doc.setFontSize(12)
      doc.text(`Financial Year: ${fyLabel}`, pageWidth / 2, cursorY + 10, { align: 'center' })
      cursorY += 20
    }

    const cur = currency || 'INR'

    // Build left (Owner Equity & Liabilities) and right (Assets) rows separately
    const leftRows = []
    let li = 0

    const isEquitySubhead = (shname) => {
      if (!shname) return false;
      const s = String(shname).toLowerCase();
      return s.includes('capital') || s.includes('equity') || s.includes('partner') || s.includes('share');
    };

    const allLiabilities = this.state.liabilities || [];
    const equityLedgers = allLiabilities.filter(l => isEquitySubhead(l.shname));
    const nonEquityLiabilities = allLiabilities.filter(l => !isEquitySubhead(l.shname));
    const nonEquityGroups = [...new Set(nonEquityLiabilities.map(l => l.shname))];

    const capitalTotal = equityLedgers.reduce((sum, l) => sum + (Number(l.amount) || 0), 0);
    let statutoryReserve = 0;
    let retainedEarnings = 0;
    let ownerEquityAmount = 0;
    let partnerAllocs = [];

    if (this.state.partnerCurrentRecord) {
      const pcRec = this.state.partnerCurrentRecord;
      ownerEquityAmount = Number(pcRec.totalAmount || 0);
      try {
        const rawAllocs = typeof pcRec.partnerDetails === 'string'
          ? JSON.parse(pcRec.partnerDetails)
          : pcRec.partnerDetails || [];
        partnerAllocs = rawAllocs.map(p => ({
          partnerId: p.partnerId,
          partnerName: p.partnerName,
          sharePercentage: p.sharePercentage,
          allocatedAmount: p.closingAmount !== undefined ? p.closingAmount : p.allocatedAmount
        }));
      } catch (e) { partnerAllocs = []; }

      if (this.state.profitDistributionRecord) {
        const rec = this.state.profitDistributionRecord;
        if (Number(rec.netProfit) < 0) {
          statutoryReserve = 0;
          retainedEarnings = rec.retainedEarningsAmount !== null && Number(rec.retainedEarningsAmount) < 0 
            ? Number(rec.retainedEarningsAmount) 
            : -Math.abs(Number(rec.netProfit));
        } else {
          statutoryReserve = Number(rec.statutoryReserveAmount || 0);
          retainedEarnings = Number(rec.retainedEarningsAmount || 0);
        }
      } else {
        if (this.state.debitexcess > 0) retainedEarnings = Number(this.state.debitexcess);
        else if (this.state.creditexcess > 0) retainedEarnings = -Number(this.state.creditexcess);
      }
    } else if (this.state.profitDistributionRecord) {
      const rec = this.state.profitDistributionRecord;
      if (Number(rec.netProfit) < 0) {
        statutoryReserve = 0;
        retainedEarnings = rec.retainedEarningsAmount !== null && Number(rec.retainedEarningsAmount) < 0 
          ? Number(rec.retainedEarningsAmount) 
          : -Math.abs(Number(rec.netProfit));
        ownerEquityAmount = Number(rec.totalDistributedAmount || 0);
      } else {
        statutoryReserve = Number(rec.statutoryReserveAmount || 0);
        retainedEarnings = Number(rec.retainedEarningsAmount || 0);
        ownerEquityAmount = Number(rec.totalDistributedAmount || 0);
      }

      try {
        partnerAllocs = typeof rec.partnerAllocations === 'string'
          ? JSON.parse(rec.partnerAllocations)
          : rec.partnerAllocations || [];
      } catch (e) { partnerAllocs = []; }
    } else {
      if (this.state.debitexcess > 0) retainedEarnings = Number(this.state.debitexcess);
      else if (this.state.creditexcess > 0) retainedEarnings = -Number(this.state.creditexcess);
    }

    const totalPartnersEquity = capitalTotal + statutoryReserve + ownerEquityAmount + retainedEarnings;

    const fmtPdf = (val) => {
      if (val === null || val === undefined || val === '') return '-';
      const num = Number(val);
      if (isNaN(num) || num === 0) return '-';
      if (num < 0) return `(${Math.abs(num).toFixed(2)})`;
      return num.toFixed(2);
    };

    leftRows[li++] = ['Owner Equity and Liabilities', ''];
    leftRows[li++] = ['Owner Equity:', ''];
    leftRows[li++] = ['  capital', fmtPdf(capitalTotal)];
    leftRows[li++] = ['  Statutory reserve', fmtPdf(statutoryReserve)];
    leftRows[li++] = ['  Owner Equity', fmtPdf(ownerEquityAmount)];
    if (partnerAllocs && partnerAllocs.length > 0) {
      partnerAllocs.forEach(p => {
        leftRows[li++] = [`    ${p.partnerName}${p.sharePercentage ? ` (${p.sharePercentage}%)` : ''}`, fmtPdf(p.allocatedAmount)];
      });
    }
    leftRows[li++] = ['  Retained earnings', fmtPdf(retainedEarnings)];
    leftRows[li++] = ['Total Partners\' Equity', fmtPdf(totalPartnersEquity)];

    // Non-equity liabilities
    nonEquityGroups.forEach(sh => {
      leftRows[li++] = [sh || '', ''];
      nonEquityLiabilities.filter(l => l.shname === sh).forEach(l => {
        leftRows[li++] = [`  ${l.ledname || l.name}`, (Number(l.amount) || 0).toFixed(2)];
      });
    });

    const rightRows = []
    let ri2 = 0
    const asstGroups = [...new Set((this.state.assets || []).map(a => a.shname))]
    asstGroups.forEach(sh => {
      rightRows[ri2++] = [sh || '', '']
      ;(this.state.assets || []).filter(a => a.shname === sh).forEach(a => {
        rightRows[ri2++] = [`  ${a.ledname || a.name}`, (Number(a.amount) || 0).toFixed(2)]
      })
    })

    const liabilitiesTotal = (this.state.liabval || 0) + ((this.state.creditexcess && this.state.creditexcess>0)? -Math.abs(this.state.creditexcess) : (this.state.debitexcess && this.state.debitexcess>0)? Math.abs(this.state.debitexcess) : 0) + (this.state.astdif || 0)
    const assetsTotal = (this.state.asstval || 0) + (this.state.liadif || 0)

  // Pad the shorter table so totals appear on the same horizontal line
  const leftLen = leftRows.length
  const rightLen = rightRows.length
  const maxLen = Math.max(leftLen, rightLen)
  for (let i = leftLen; i < maxLen; i++) leftRows[li++] = ['', '']
  for (let i = rightLen; i < maxLen; i++) rightRows[ri2++] = ['', '']

  // Append totals as the last rows so autoTable aligns them with the table columns
  leftRows[li++] = ['Liabilities Total', this.state.finalLiabilities.toFixed(2) || 0]
  rightRows[ri2++] = ['Asset Total', this.state.finalAssets.toFixed(2) || 0]

  // Combined single table layout (4 columns) so rows and totals align exactly
  const usableWidth = pageWidth - marginLeft * 2

    // Build combined rows (4 columns): [L_particulars, L_amount, R_particulars, R_amount]
    const maxLen2 = Math.max(leftRows.length, rightRows.length)
    const combined = []
    for (let i = 0; i < maxLen2; i++) {
      const l = leftRows[i] || ['', '']
      const r = rightRows[i] || ['', '']
      combined.push([l[0] || '', l[1] || '', r[0] || '', r[1] || ''])
    }

    const head = [[`Owner Equity and Liabilities`, `Amount`, `Assets`, `Amount`]]

    // Render single 4-column table and capture result to draw center separator
    // @ts-ignore
    const res = doc.autoTable({
      head: head,
      body: combined,
      startY: cursorY,
      margin: { left: marginLeft, right: marginLeft },
      styles: { fontSize: 9, cellPadding: 2, overflow: 'linebreak' },
  headStyles: { fillColor: [230, 230, 230], halign: 'left' },
      columnStyles: {
        0: { cellWidth: usableWidth * 0.4 },
        1: { halign: 'right', cellWidth: usableWidth * 0.1 },
        2: { cellWidth: usableWidth * 0.4 },
        3: { halign: 'right', cellWidth: usableWidth * 0.1 }
      },
      didParseCell: function(data) {
        // style group headers when they occur in the left/right particulars columns
        if (data.section === 'body' && (data.column.index === 0 || data.column.index === 2)) {
          const raw = data.row.raw && data.row.raw[data.column.index]
          if (raw && String(raw).indexOf('  ') !== 0) {
            data.cell.styles.fontStyle = 'bold'
            data.cell.styles.fillColor = [245, 245, 245]
            data.cell.styles.halign = 'left'
          }
        }
      },
      theme: 'grid'
    })

    // (separator line removed per request)

    const fname = `BalanceSheet_${this.state.fyfrom || 'FY'}.pdf`
    doc.save(fname)
  } catch (e) {
    console.error('Failed to export PDF', e)
    alert('Export to PDF failed: ' + (e && e.message ? e.message : 'unknown'))
  }
}

export default withRouter(BalanceSheet);
